import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Col, withResponsiveHelper} from '@modifi/ui'

import {Wrapper, OverlayWrapper, StyledH4, CTAWrapper, StyledRow} from './styles'
import LinkComponent from '../link-component'

const propTypes = {
  text: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaTargetUrl: PropTypes.string,
  ctaType: PropTypes.string,
  ctaOpenInNewTab: PropTypes.bool,
  isXs: PropTypes.bool,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  text: undefined,
  ctaLabel: undefined,
  ctaTargetUrl: undefined,
  ctaType: undefined,
  ctaOpenInNewTab: false,
  isXs: false,
  backgroundColor: undefined,
}

export type OverlappingTextWithCtaProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const OverlappingTextWithCta: React.FC<OverlappingTextWithCtaProps> = ({
  text,
  ctaLabel,
  ctaOpenInNewTab,
  ctaTargetUrl,
  ctaType,
  isXs,
  backgroundColor,
}) => (
  <Wrapper backgroundColor={backgroundColor}>
    <OverlayWrapper>
      <StyledRow alignItems="center" justifyContent={ctaType && !isXs ? 'between' : 'center'}>
        <Col col={ctaType && !isXs ? 7 : 12} md={ctaType && !isXs ? 9 : 12}>
          <StyledH4>{text}</StyledH4>
        </Col>
        {ctaType && (
          <Col col={text && !isXs ? 5 : 12} md={text && !isXs ? 3 : 12}>
            <CTAWrapper>
              <LinkComponent
                targetUrl={ctaTargetUrl!}
                label={ctaLabel!}
                type={ctaType!}
                openInNewTab={ctaOpenInNewTab!}
              />
            </CTAWrapper>
          </Col>
        )}
      </StyledRow>
    </OverlayWrapper>
  </Wrapper>
)

OverlappingTextWithCta.propTypes = propTypes

OverlappingTextWithCta.defaultProps = defaultProps

export default withResponsiveHelper(OverlappingTextWithCta)
